import {SvgIcon} from "@mui/material";

function Chart({sx, ...props}) {
    return <SvgIcon sx={sx} {...props}>
        <path
            d="M4.00078 18.9998H8.87578V10.9998H4.00078V18.9998ZM9.57578 18.9998H14.4258V4.9998H9.57578V18.9998ZM15.1258 18.9998H20.0008V12.9998H15.1258V18.9998ZM3.30078 19.6998V10.2998H8.87578V4.2998H15.1258V12.2998H20.7008V19.6998H3.30078Z"/>
    </SvgIcon>
}

export {Chart};